<template>
	<!-- :class="{
			'bg-gray-100': page.page_link == 'frequently-asked-questions',
			'bg-white': page.page_link != 'frequently-asked-questions'
		}" -->
	<div class="w-full  bg-black text-slate-200 selection:bg-blue-500/30 font-sans relative min-h-screen overflow-hidden">
		<!-- Ambient Glows -->
		<div class="absolute top-0 left-[-10%] w-[70vw] h-[70vw] md:w-[40vw] md:h-[40vw] bg-blue-600/10 blur-[120px] rounded-full pointer-events-none z-0"></div>
		<div class="absolute bottom-0 right-[-10%] w-[70vw] h-[70vw] md:w-[40vw] md:h-[40vw] bg-blue-600/10 blur-[120px] rounded-full pointer-events-none z-0"></div>
		
		<div class="w-full relative z-10">
			<div
				class="container mx-auto link-sheet-20 px-12 py-36 md:p-24 lg:p-36"
			>
				<div class="w-full mx-auto">
					<div
						class="text-5xl md:text-6xl xl:text-7xl font-extrabold text-white pt-16 pb-2 tracking-tight drop-shadow-2xl paydeck-masthead-header"
					>
						<span v-if="ifSupport"> We're here to help! </span>
						<span v-else>
							{{ page.page_caption }}
						</span>
					</div>
				</div>
			</div>
		</div>
		<div
			class="z-30 container mx-auto py-12 px-12 md:px-24 lg:px-36 md:pb-24 rounded-xl relative"
		>
			<Support v-if="ifSupport"></Support>

			<div v-if="page.page_link == 'frequently-asked-questions'">
				<FAQ :faqs="faqs" />
			</div>

			<div v-if="!page.page_type">
				<BasicComponents :sections="sections" />
			</div>

			<div v-if="page.page_type">
				<AdvancedComponents :sections="sections" />
			</div>
		</div>
	</div>
</template>

<script>
import service_manager from "../api/service_manager.js";
import service_manager_base from "../api/service_manager_base.js";

import Support from "../views/Support";
import BasicComponents from "../components/BasicComponents";
import AdvancedComponents from "../components/AdvancedComponents";
import FAQ from "../components/FAQ";

// import request from "request";
import common from "../mixins/common";

export default {
	components: {
		Support,
		BasicComponents,
		AdvancedComponents,
		FAQ
	},
	props: ["link"],
	mixins: [common],
	data() {
		return {
			page: {
				_id: "",
				page_id: "",
				page_link: "-",
				page_title: "...",
				page_caption: "...",
				page_image_link: "-",
				page_type: false,
				contents: [""],
				page_meta_tags: ""
			},
			sections: [],
			ifSupport: false,
			faqs: []
		};
	},
	methods: {
		getBackImage(image_url) {
			// console.log(image_url);
			if (image_url.length > 2) {
				return {
					"background-image":
						"linear-gradient( rgba(0,0,0,.7), rgba(0,0,0,.5) ), url('" +
						this.image_base_url +
						image_url +
						"')"
					//  'background-colour': 'rgba(0,0,0,0.5)'
				};
			}
		},
		getSections() {
			var app = this;
			console.log(app.link);
			service_manager("post", "/api/data/fetch/site_pages/0/0", {
				query: {
					page_link: app.link
				},
				show: {},
				sort: {}
			})
				.then((res) => {
					// console.log(res.data.response);
					if (res.data.response.data.length > 0) {
						app.page = res.data.response.data[0];
						// if (app.page.page_meta_tags.length > 5) {
						// 	$("head").append(app.page.page_meta_tags);
						// }

						// $("#page_header").css(
						// 	"background-image",
						// 	"linear-gradient(rgba(0, 0, 0, .6), rgba(0, 0, 0, .4)), url('" +
						// 		app.image_base_url +
						// 		app.page.page_image_link +
						// 		"')"
						// );
						// $("#page_header").css("background-size", "cover");
						// $("#page_header").css("background-position", "center");
						if (app.link != "frequently-asked-questions")
							return service_manager(
								"post",
								"/api/data/fetch/site_page_contents/0/0",
								{
									query: {
										_id: app.page.contents
									},
									show: {},
									sort: {
										section_order: 1
									}
								}
							);
					}
				})
				.then((res) => {
					if (app.link != "frequently-asked-questions") {
						console.log(res.data.response);
						app.sections = res.data.response.data;
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
		getFaqs() {
			var options = {
				url: "https://paydeck.freshdesk.com/api/v2/solutions/folders/16000031790/articles",
				headers: {
					Authorization: "Basic QmJ6bW1jSDBLR0tvaWNsM3VrRDE6WA=="
				}
			};

			service_manager("post", "/api/pay/fetch", {
				url: options.url,
				headers: options.headers
			})
				.then((res) => {
					console.log(res);
					this.faqs = res.data.response.data;
				})
				.catch((err) => {
					console.log(err);
				});

			// request(options, (error, response, body) => {
			// 	if (!error && response.statusCode == 200) {
			// 		console.log(
			// 			"Fresh Desk Response ==================================="
			// 		);
			// 		var info = JSON.parse(body);
			// 		console.log(info);
			// 		this.faqs = info;
			// 	}
			// });
		},
		stripStyles(text) {
			var qtext = text.split('"');
			var string = "";
			for (var i = 0; i < qtext.length; i++) {
				if (i % 2 == 0)
					string += qtext[i]
						.replace("style=", "")
						.replace("data-identifyelement=", "")
						.replace("dir=", "");
				else {
					if (i - 1 >= 0) {
						if (
							qtext[i - 1].indexOf("style=") == -1 &&
							qtext[i - 1].indexOf("data-identifyelement=") ==
								-1 &&
							qtext[i - 1].indexOf("dir=") == -1
						) {
							string += '"' + qtext[i] + '"';
						}
					}
				}
			}
			return string
				.split("<br>")
				.join("")
				.split("<br >")
				.join("")
				.split(".<strong >")
				.join(".<br><strong >")
				.split(".<strong>")
				.join(".<br><strong>")
				.split("><strong >")
				.join("><br><strong >")
				.split("><strong>")
				.join("><br><strong>")
				.split(".</strong>")
				.join(".</strong> ");
		}
	},
	mounted() {
		if (window.location.href.indexOf("frequently-asked-questions") != -1)
			this.getFaqs();
		this.getSections();
		this.ifSupport = this.link == "help-center";
	}
};
</script>

<style scoped>
.paydeck-masthead-header {
	text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
}
.paydeck-masthead-image * {
	width: 0vw;
	margin-top: -3vh;
	max-width: unset;
	overflow: hidden !important;
	z-index: -1;
}
.zero {
	width: 100vw;
	padding-bottom: 5vh;
	background-position: center;
	background-repeat: no-repeat;
	background-size: contain;
}
.link-sheet-20 {
	width: 100%;
	z-index: 10 !important;
	overflow: hidden !important;
	position: relative;
}
.span-color-4 {
	background-image: linear-gradient(#ff9680, #ffccde) !important;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	-moz-background-clip: text;
	-moz-text-fill-color: transparent;
}
.span-blue {
	color: #3913b8;
}
.span-blue-1 {
	color: #2249b3;
}
.span-white {
	color: rgba(255, 255, 255, 0.7);
}
.span-white-1 {
	color: rgba(255, 255, 255, 0.87);
}
.get-started-button {
	align-items: center;
	padding: 15px 33px;
	width: 197px;
	height: 54px;
	background: linear-gradient(91.96deg, #3913b8 0%, #ba75ff 100%);
	box-shadow: 0px 20px 40px rgba(113, 62, 215, 0.3);
	border-radius: 30px;
	transition: all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
.get-started-button:hover {
	transform: translateY(-5px);
	box-shadow: 0px 20px 40px rgba(113, 62, 215, 0.8);
}
.separate {
	bottom: 100px !important;
}

.payment-payout-background {
	/* background: linear-gradient(
		139.43deg,
		#3913b8 12.46%,
		rgba(57, 19, 184, 0) 101.08%
	); */
	background-image: radial-gradient(
		circle 300px at 8% 89.3%,
		rgba(20, 157, 208, 1) 0%,
		rgba(140, 63, 226, 1) 90%
	);
	position: relative;
}
.limit-card {
	padding: 30px;
	background: rgba(88, 105, 255, 0.1);
	backdrop-filter: blur(30px);
	border-radius: 20px;
}
.simple-card {
	background: #ffffff;
	box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.05),
		0px 20px 40px rgba(92, 103, 153, 0.2);
	border-radius: 30px;
	padding: 20px;
	transition: all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
.simple-card:hover {
	transform: translateY(-5px);
	box-shadow: 10px 1px 3px rgba(0, 0, 0, 0.05),
		10px 20px 40px rgba(92, 103, 153, 0.2);
}
.rounded-number {
	background: #dbe1ff;
	height: 30px !important;
	width: 30px;
	border-radius: 50%;
	text-align: center;
	padding: 5px;
}
.chip-background {
	background: rgba(0, 0, 0, 0.2);
	border-radius: 5px;
}
.start-now {
	position: relative;
	background: rgba(255, 255, 255, 0.9);
	box-shadow: 0px 20px 40px rgba(23, 0, 102, 0.3);
	border-radius: 30px;
	transition: 0.3s ease-in-out;
	width: 280px;
	cursor: pointer;
}
.start-now:hover {
	box-shadow: 0px 20px 40px rgba(23, 0, 102, 0.6);
	transform: translateY(-4px);
}

/* Responsive Screen */
/* FOR 2XL Displays */
@media only screen and (min-device-width: 1441px) and (max-device-width: 2160px) {
	.paydeck-masthead-image * {
		width: 0vw;
	}
	.zero {
		width: 100vw;
		background-position: bottom;
		background-repeat: no-repeat;
		background-size: cover;
	}
}
/* FOR XL Displays */
@media only screen and (min-device-width: 1022px) and (max-device-width: 1440px) {
	.paydeck-masthead-image * {
		width: 0vw;
	}
	.zero {
		width: 100vw;
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
	}
}
/* FOR TABLET landscape*/
@media only screen and (max-device-width: 1023px) and (min-device-width: 768px) and (orientation: landscape) {
	.paydeck-masthead-image * {
		width: 100vw;
	}
	.zero {
		background-size: 0%;
	}
}
/* FOR TABLET portrait*/
@media only screen and (max-device-width: 1023px) and (min-device-width: 768px) and (orientation: portrait) {
	.paydeck-masthead-image * {
		width: 100vw;
	}
	.zero {
		background-size: 0%;
	}
}
/* FOR MOBILE */
@media only screen and (max-device-width: 767px) {
	.paydeck-masthead-image * {
		opacity: 0;
	}
	.zero {
		width: 100vw;
		background-position: 24%;
		background-repeat: no-repeat;
		background-size: cover;
		padding-bottom: 10vh;
		margin-bottom: -10vh;
	}
	.link-sheet-20 {
		width: 100%;
		z-index: 10 !important;
		overflow: hidden !important;
		position: relative;
	}
}
</style>
